import React, { useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import dataLoaderServices from "./DataLoaderServices";
import DataLoaderInvalid from "./DataLoaderInvalid";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";
import CurrentJobs from "components/User Profile/CurrentJobs";
import directoryServices from "components/directories/directoryServices";

export default function DataLoaderFileValidation(param: any) {

    console.log(param)
    let [fileName, setFileName] = useState<any>([]);
    let [ErrorName, setErrorName] = useState<any>([]);
    let [ErrorFound, setErrorFound] = useState(true);
    let [selectFile, setSelectFile] = useState<any>([]);
    let [commitFile, setCommitFile] = useState<any>([]);
    let [commitStatus, setCommitStatus] = useState(false);
    let [confirmStatus, setConfirmStatus] = useState(false);
    let [validationOpen, setValidationOpen] = useState(false);
    let [assetvalidation, setassetvalidation] = useState<any>([]);
    let [viewMoreFileName, setViewMoreFileName] = useState<any>([]);

    useEffect(() => {

        if (param.open) {

            validationFile();

            viewMoreFileName = "";
            setViewMoreFileName(viewMoreFileName);

            upload_summary_listing()
        }
    }, [param.open]);

    useEffect(() => {

        var tempvalue = [];
        tempvalue = assetvalidation?.filter((ErrorListing: any) => ErrorListing.count !== 0);

        if (tempvalue.length > 0) {
            ErrorFound = true
            setErrorFound(ErrorFound)
        }

        if (tempvalue.length === 0) {
            ErrorFound = false;
            setErrorFound(ErrorFound)
        }

        commitStatus = false;
        setCommitStatus(commitStatus);

    }, [assetvalidation]);

    let [upload_Summary, setUpload_Summary] = useState(false);
    let [UploadSummaryList, setUploadSummaryList] = useState<any>([]);
    const upload_summary_listing = () => {
        var uploadType = param?.type
        if (param?.type == "Minimum Set Uploader") { uploadType = param?.subType }

        dataLoaderServices.genericAPIListing({ type: "uploadSummary", uploadType: uploadType }).then((res) => {
            UploadSummaryList = CommonUtilities.relativeDataRemapping(res.data, res.headers.original)

            if (UploadSummaryList.length > 0) {
                upload_Summary = true
                setUpload_Summary(upload_Summary)
                setUploadSummaryList(UploadSummaryList);
            }
        })

        dataLoaderServices.genericAPIListing({ type: param?.type?.replace(/\s+/g, "") + "_uploader_result", uploadType: param?.subType }).then((res) => {
            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            errorCount = res?.totalRows
            setErrorCount(errorCount);
        })

    }

    const returnValue = (e: any) => {
        param.onFileValidation(e)
    }

    const validationFile = () => {
        var type = ""
        assetvalidation = [];
        validation_list_set(assetvalidation)

        CommonUtilities.APILoadingToast('Loading', 'fail')

        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.dataLoadContactValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadContractLinksValidation().then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadmechanicalUploadValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Mappings') {
            dataLoaderServices.dataLoadMappingValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataLoaddataTransferValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataLoaddataTransferValidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Minimum Set Uploader') {
            dataLoaderServices.metadatavalidation({ type: param.subType }).then((res: any) => { validation_list_set(res) });
        }

        if (param.type === 'Minimum Set Uploader') {
            dataLoaderServices.metadatavalidation({ type: param.subType }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'CWR') {
            dataLoaderServices.CWRvalidation({ type: "songCWR" }).then((res: any) => {
                const distinct = Array.from(new Set(res.map((item: any) => item.fileName))).map(filename => ({ filename }));
                validation_list_set(res)
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
                fileName = distinct;
                setFileName(fileName)
            });
        }

        if (param.type === 'CUE') {
            dataLoaderServices.CUEvalidation().then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Song') {
            dataLoaderServices.dataLoadSongValidation().then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Release/Track' && (param.subType == "releaseTrack" || param.subType == "Distributor")) {
            dataLoaderServices.MetaDatatrackReleasevalidation().then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Release/Track' && param.subType == "Releases") {
            dataLoaderServices.genericV1validation({ type: "release" }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Release/Track' && param.subType == "Track") {
            dataLoaderServices.genericV1validation({ type: "track" }).then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === "suggestedPayments") {
            dataLoaderServices.suggestedPaymentsvalidation().then((res: any) => {
                validation_list_set(res);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }
    }

    let [validate_count, setValidate_count] = useState(0);
    let [errorCount, setErrorCount] = useState(0);

    const validation_list_set = (respond: any) => {
        assetvalidation = respond
        setassetvalidation(assetvalidation);

        var validation_count = 0
        var error_count = 0

        for (var i = 0; i < respond.length; i++) {

            if (respond[i].count != 0) {
                validation_count = validation_count + 1
                error_count = error_count + respond[i].count;
                validate_count = validation_count
                setValidate_count(validate_count)
            }
        }

    }

    const validationList = (e: any) => {

        if (param?.type != "Upload Mechanicals" && param?.type != "Mappings") {

            ErrorName = e;
            setErrorName(ErrorName)
            validationOpen = true;
            setValidationOpen(validationOpen)
        }
    }

    const CommitFileUpload = () => {

        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.dataLoadContractCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadContractLinksCommit().then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadMechanicalCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Mappings') {
            dataLoaderServices.dataLoadMappingCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataTransferCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Release/Track' && param.subType == "Releases") {
            dataLoaderServices.genericV1MetadataCommit({ type: param.subType }).then((res: any) => { commitStatus = true; setCommitStatus(commitStatus) });
        }

        if (param.type === 'Release/Track' && (param.subType == "releaseTrack" || param.subType == "Track")) {
            confirmStatus = true;
            setConfirmStatus(confirmStatus)
        }

        if (param.subType === "Bundle") {
            directoryServices.fileCommit("Bundles", null).then(() => { setConfirmStatus(true) })
        }
        if (param.subType === "Tracks") {
            directoryServices.fileCommit("tracks", 0).then(() => { setConfirmStatus(true) })
        }
        if (param.subType === "Releases") {
            directoryServices.fileCommit("release", 0).then(() => { setConfirmStatus(true) })
        }
        if (param.subType === "Songs") {
            directoryServices.fileCommit("release", 0).then(() => { setConfirmStatus(true) })
        }

        if (param.subType === "Dealerprice") {
            dataLoaderServices.DealerPriceCommit({ type: param.subType }).then(() => { setConfirmStatus(true) })
        }


        if (param.type === 'CWR') {
            var type = 'All'
            if (commitFile.length > 0) {
                var tempvalue = assetvalidation?.filter((ErrorListing: any) => ErrorListing.fileName === commitFile)[0]?.jobId;
                type = 'None'
            }

            dataLoaderServices.processThisCWRFile({ fileName: type, jobId: tempvalue }).then(() => validationFile())
        }

        if (param.type === 'CUE') {

            dataLoaderServices.cuecommit().then((res: any) => { validation_list_set(res) });
        }
    }

    const onChangeInvalid = (e: any) => {
        validationOpen = false;
        setValidationOpen(validationOpen);
        validationFile();
    }

    const deleteConfirmation = (e: any) => {
        if (e == 1) {

            if (param.subType == "releaseTrack") {
                dataLoaderServices.saveISRCPrefix({ type: "metadatageneric" }).then(() => {
                    dataLoaderServices.genericV1MetadataCommit({ operation: "ALL" }).then(() => {

                        dataLoaderServices.UpdateNextIRSCommit({ type: "metadatageneric" })
                    })

                })
            }

            if (param.subType == "Track") {
                dataLoaderServices.saveISRCPrefix({ type: "metadatatrack" }).then(() => {
                    dataLoaderServices.genericV1MetadataCommit({ type: "track" }).then(() => {

                        dataLoaderServices.UpdateNextIRSCommit({ type: "metadatatrack" })
                    })
                })
            }

        }

        //2 NO
        if (e == 2) {

            if (param.subType == "releaseTrack") {
                dataLoaderServices.genericV1MetadataCommit({ operation: "ALL" })
            }

            if (param.subType == "Track") {
                dataLoaderServices.genericV1MetadataCommit({ type: "type" })
            }
        }

        commitStatus = true;
        setCommitStatus(commitStatus)

        confirmStatus = false;
        setConfirmStatus(confirmStatus)
    }

    const viewMore = (e: any) => {

        if (viewMoreFileName == e?.filename) {
            viewMoreFileName = "";
            setViewMoreFileName(viewMoreFileName)
        } else {

            viewMoreFileName = e?.filename;
            setViewMoreFileName(viewMoreFileName)
        }
    }

    const rejectFile = (e: any) => {
        selectFile = e
        setSelectFile(selectFile)
    }

    const selectConfirmation = (e: any) => {

        var tempvalue = assetvalidation?.filter((ErrorListing: any) => ErrorListing.fileName === selectFile)[0]?.jobId;
        //console.log(tempvalue)

        if (e == 1) {
            dataLoaderServices.rejectCWRFile({ fileName: e, jobId: tempvalue }).then(() => validationFile())
        }

        selectFile = ''
        setSelectFile(selectFile)
    }

    return (
        <div className="ws-12 allowHscroll allowVscroll" style={{ maxWidth: "50px !important", top: "100px !important" }}>
            <Modal open={param.open} onClose={() => returnValue(0)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent allowHscroll allowVscroll' }} >

                <div className="box landing allowHscroll allowVscroll">

                    <div className="box-header-main ws-12" style={{ width: "40% !important" }}>
                        <h2 className="pull-left ws-10"> File Validation</h2>
                        <div className="pull-right prxl">
                            <button className="icon-btn delete pull-right btn-m" onClick={validationFile}><i className="icon-refresh2"></i> Reset</button>
                        </div>
                    </div>

                    <div className="ws-12 pLarge">

                        {(param.type != "CWR") && <>

                            <div className="ws-12 pm  mb">

                                {upload_Summary && <div className="ws-12">

                                    <div className="w-36 m1 box leftFrameGreen">
                                        <span className="ws-12 text-bold text-center mt">Row Count</span>
                                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />

                                        <div className="ws-12 pm">
                                            <div className="ws-12 pm">
                                                <span className="ws-9 mt text-bold ">Import Row</span>
                                                <span className="ws-3 mt text-center ">{param?.uploadCount ?? 0}</span>
                                                <span className="ws-9 mt text-bold ">Row Fail</span>
                                                <span className={errorCount > 0 ? "ws-3 mt text-center danger" : "ws-3 mt text-center success"}>{errorCount}</span>
                                                <span className="ws-9 mt text-bold ">Validation Fail</span>
                                                <span className="ws-3 mt text-center "> <span className={errorCount > 0 ? "danger" : "success"}>{validate_count} </span> of {assetvalidation.length}</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="w-30 m1 box leftFramelightBlue">
                                        <span className="ws-12 text-bold text-center mt">Update</span>
                                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />

                                        <div className="ws-12 pm">
                                            {
                                                UploadSummaryList?.map((values: any) => {

                                                    if (values?.error_Type == "Update") {

                                                        return (
                                                            <div className="ws-12">
                                                                <span className="ws-6 mt text-bold pull-left forceSingleLine">{values?.errorName}</span>
                                                                <span className="ws-6 mt text-right">{values?.counting}</span>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>

                                    </div>

                                    <div className="w-30 m1 box leftFrameBlue">
                                        <span className="ws-12 text-bold text-center mt">Create</span>
                                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />

                                        <div className="ws-12 pm">
                                            {
                                                UploadSummaryList?.map((values: any) => {

                                                    if (values?.error_Type == "Create") {

                                                        return (
                                                            <div className="ws-12">
                                                                <span className="ws-6 mt text-bold pull-left forceSingleLine">{values?.errorName}</span>
                                                                <span className="ws-6 mt text-right">{values?.counting}</span>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>

                                    </div>

                                </div>}

                                <div className="ws-12 mt box  ">

                                    <table className="newTable ">
                                        <thead>

                                            <th>Validation Desciption</th>
                                            <th className="text-center">Error Count</th>
                                        </thead>
                                        <tbody>

                                            {
                                                assetvalidation?.map((values: any) => {
                                                    return (
                                                        <tr>
                                                            <td style={{ width: "35%" }} >
                                                                <div className="ws-12">
                                                                    {(values.count > 0) && <span className="pull-left pl pt mr btn-danger borderNone"><i className="icon-warning1"></i></span>}
                                                                    {(values.count === 0) && <span className="pull-left pl pt mr btn-success borderNone"><i className="icon-tick1"></i></span>}
                                                                    <span className="pull-left">{values.title}</span>
                                                                </div>

                                                            </td>
                                                            <td style={{ width: "15%" }} className="text-center" >
                                                                {(values.count > 0) && <span className="text-underline text-center" style={{ color: "red " }} onClick={() => { validationList(values.title) }}>{values.count}</span>}
                                                                {(values.count === 0) && <span>{values.count}</span>}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                    <table className="newTable hide">
                                        <tbody>

                                            {
                                                assetvalidation?.map((values: any) => {
                                                    return (
                                                        <tr>
                                                            <th style={{ width: "25%" }} className="text-right ">{values.title}</th>
                                                            <td style={{ width: "25%" }}>
                                                                {(values.count > 0) && <span className="text-underline" style={{ color: "red " }} onClick={() => { validationList(values.title) }}>{values.count}</span>}
                                                                {(values.count === 0) && <span>{values.count}</span>}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="box-footer pull-right ws-12">
                                <button className="icon-btn delete pull-right width90 height30" style={{ marginLeft: "5px" }} onClick={() => returnValue(0)}>  Close</button>
                                {!commitStatus && <button className="icon-btn edit width90 height30" disabled={ErrorFound} onClick={CommitFileUpload}>Commit</button>}

                                {commitStatus && !ErrorFound && <CurrentJobs type="button" />}

                                {((param.type === 'ReleasesTracks') || (param.type === 'Releases')) && <div className="ws-2 pull-right">
                                    <input className="btn pull-right" key="Master" type="checkbox" />
                                    <span className="forceSingleLine ws-12">Release Code As Master</span>
                                </div>}
                            </div>
                        </>}

                        {(param.type === "CWR") && <div className="ws-12">

                            <div className="ws-12">
                                <button title="Commit All" className="icon-btn info pull-right" ng-click="commitAllFiles('All')">
                                    <i className="icon-download"></i> Commit All Files
                                </button>
                            </div>

                            {fileName && fileName?.map((fileVal: any) => {

                                return (<div className="ws-4 mb mr ">
                                    <div className="box box-dash box-primary ws-12 ps">
                                        <div className="box-header pr">
                                            <h2>{fileVal?.filename ?? ""}</h2>
                                        </div>

                                        <div className="box-content p0 pt pl pr">
                                            <table >
                                                <tbody>
                                                    {assetvalidation
                                                        ?.filter((values: any) => fileVal?.filename === values?.fileName)
                                                        .slice(0, viewMoreFileName.length > 0 && viewMoreFileName == fileVal?.filename ? 100 : 10)
                                                        .map((values: any, index: any) => {

                                                            if (fileVal?.filename == values?.fileName) {

                                                                return (<tr>
                                                                    <th className="ws-10">{values.title} :</th>
                                                                    <td className="ws-2">{values.count}</td>
                                                                </tr>)
                                                            }
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="box-footer">
                                            <button className="icon-btn warning pull-left" onClick={() => viewMore(fileVal)}>
                                                <i className={viewMoreFileName.length > 0 && viewMoreFileName == fileVal?.filename ? "icon-minus1 fa-plus" : "icon-plus1 fa-plus"}></i> View {viewMoreFileName.length > 0 && viewMoreFileName == fileVal?.filename ? " less" : " more"}
                                            </button>
                                            <button className="icon-btn edit" onClick={() => { commitFile = fileVal?.filename; CommitFileUpload() }}><i className="icon-download"></i> Commit</button>
                                            <button className="icon-btn delete" onClick={() => rejectFile(fileVal?.filename)}><i className="icon-close"></i> Reject</button>
                                        </div>
                                    </div>
                                </div>)
                            })}
                        </div>}
                    </div>

                </div>

                {(() => {

                    if (validationOpen) {
                        return (<DataLoaderInvalid onChangeLoadFile={onChangeInvalid} open={validationOpen} type={param.type} subType={param.subType} errorName={ErrorName} />)
                    }

                    if (confirmStatus) {
                        return <DeleteDialogueBox param={true} message={"update the next available ISRCs for the labels"} onChange={deleteConfirmation} />
                    }


                    if (selectFile?.length > 0) {
                        return <DeleteDialogueBox param={true} message={"you want to reject the file song " + selectFile} onChange={selectConfirmation} />
                    }

                })()}

            </Modal>
        </div>
    )
}